import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import naive from "naive-ui";
import store from "./store";
import "@/assets/css/global.css";

router.afterEach((to) => {
  const title = to.meta.title as string;
  if (title) {
    document.title = title;
  } else {
    document.title = "COKOLAB. Inc.";
  }
});

createApp(App).use(store).use(router).use(naive).mount("#app");
